// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","submit":"submit-1flzQ","button":"button-3jA3g","button_checked":"button_checked-BN8j3","header":"header-1ZzPP","field":"field-1qRVe"};